/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdWebFeaturesProfileFetchFxIdGameConnectionFetchGameConnectionSuccessfulResult, FxIdWebFeaturesProfileFetchFxIdGameConnectionFetchGameConnectionSuccessfulResultFromJSONTyped, FxIdWebFeaturesProfileFetchFxIdGameConnectionFetchGameConnectionSuccessfulResultToJSON, } from './FxIdWebFeaturesProfileFetchFxIdGameConnectionFetchGameConnectionSuccessfulResult';
export function FxIdWebFeaturesProfileFetchFxIdGameConnectionResponseResultFromJSON(json) {
    return FxIdWebFeaturesProfileFetchFxIdGameConnectionResponseResultFromJSONTyped(json, false);
}
export function FxIdWebFeaturesProfileFetchFxIdGameConnectionResponseResultFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdWebFeaturesProfileFetchFxIdGameConnectionFetchGameConnectionSuccessfulResult(json)) {
        return FxIdWebFeaturesProfileFetchFxIdGameConnectionFetchGameConnectionSuccessfulResultFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdWebFeaturesProfileFetchFxIdGameConnectionResponseResultToJSON(json) {
    return FxIdWebFeaturesProfileFetchFxIdGameConnectionResponseResultToJSONTyped(json, false);
}
export function FxIdWebFeaturesProfileFetchFxIdGameConnectionResponseResultToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdWebFeaturesProfileFetchFxIdGameConnectionFetchGameConnectionSuccessfulResult(value)) {
        return FxIdWebFeaturesProfileFetchFxIdGameConnectionFetchGameConnectionSuccessfulResultToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdWebFeaturesProfileFetchFxIdGameConnectionResponseResult.js.map